export default function Footer() {
  return (
    <footer className="bg-gray-50 border-t border-gray-200 text-center text-sm text-gray-500 py-6">
      <span className="font-semibold text-black">Mindzera:</span>{' '}
      <span className="text-emerald-600">The AI-supported cognitive operating system</span>
    </footer>
  );
}
